import { render, staticRenderFns } from "./VimeoPlayer.vue?vue&type=template&id=136e63de&scoped=true"
import script from "./VimeoPlayer.vue?vue&type=script&lang=js"
export * from "./VimeoPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136e63de",
  null
  
)

export default component.exports